module.exports = window["wp"]["privateApis"];